<template>
  <div ref="tippyContent" class="hidden">
    <div class="p-2">
      <ul
        class="grid grid-cols-1 sm:grid-cols-3 gap-y-2 sm:gap-y-3 sm:gap-x-4"
        style="width: 100%;"
      >
        <li 
          v-if="fileExt && fileSize"
          class="col-span-1"
        >
          <div class="font-bold pb-0.5">
            {{ $t('Type and size') }}:
          </div>
          <div>.{{ fileExt }} {{ formatBytes(fileSize) }}</div>
        </li>
        <li 
          v-if="element.file?.uploaded_by__user"
          class="col-span-1" 
        >
          <div class="font-bold pb-0.5">
            {{ $t('Uploaded by') }}:
          </div>
          <div>{{ element?.file?.uploaded_by__user.name }} {{ element?.file?.uploaded_by__user.surname }}</div>
        </li>
        <li 
          v-if="fileUploaded"
          class="col-span-1" 
        >
          <div class="font-bold pb-0.5">
            {{ $t('Uploaded') }}:
          </div>
          <div>{{ formatDate(fileUploaded, 'd. m. Y H:i') }}</div>
        </li>
        <li 
          v-if="antivirusState && antivirusState !== 'hasVirus' && !element.file?.deleted"
          class="col-span-3"
        >
          <div class="font-bold pb-0.5">
            {{ $t('Antivirus') }}:
          </div>
          <div 
            v-if="antivirusState === 'waiting'"
            class="flex items-center justify-start"
          >
            <aw-icon 
              icon="safety-check" 
              class="w-5 h-5 mr-1 flex-shrink-0"
            />
            <div>
            {{ $t('File is being checked for viruses') }}
            </div>
          </div>
          <div 
            v-if="antivirusState === 'checked'"
            class="flex items-center justify-start"
          >
            <aw-icon 
              icon="verified-user" 
              class="w-5 h-5 mr-1 flex-shrink-0"
            />
            {{ $t('File is safe') }}
          </div>
        </li>
        <li 
          v-if="element?.file?.tags?.length > 0"
          class="col-span-3"
        >
          <div class="font-bold pb-0.5">
            {{ $t('Tags') }}:
          </div>
          <div class="flex items-start justify-start">
            <aw-icon 
              icon="tags" 
              class="w-5 h-5 mr-1 flex-shrink-0"
            />
            {{ element.file.tags.join(', ') }}
          </div>
        </li>
        <li 
          v-for="(item, i) in metadata"
          :key="i"
          class="col-span-1"
        >
          <div class="font-bold pb-0.5">
            {{ $t('EXIF_' + item.name) }}:
          </div>
          <div v-html="item.value" />
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { ref, watch } from 'vue'
import { useTippy } from 'vue-tippy'

export default {
  props: {
    antivirusState:{
      type: String,
      default: null
    },
    element:{
      type: Object,
      default: null
    },
  },
  computed: {
    fileExt() {
      return this.element.file ? this.element.file.ext : this.element.file_upload.ext
    },
    fileSize() {
      return this.element.file ? this.element.file.size : this.element.file_upload.size
    },
    fileUploaded() {
      return this.element.file ? this.element.file.uploaded : this.element.file_upload.upload_start
    }
  },
  setup(props) {
    const tippyContent = ref(null)
    let tippyWidth = 0

    const getAppendToElement = (el) => {
      return () => {
        const PageElementsEl = el.closest('.PageElements')
        const GalleryListEl = el.closest('.GalleryList')

        if (!PageElementsEl && GalleryListEl) {
          const GalleryList__ItemEl = el.closest('.GalleryList__Item')
          tippyWidth = GalleryList__ItemEl.offsetWidth * 3
          return GalleryListEl
        }

        tippyWidth = PageElementsEl.offsetWidth
        return PageElementsEl
      }
    }

    watch(tippyContent, (val) => {
      if (!val) {
        return
      }

      useTippy(val.parentElement, {
        content: () => val.firstElementChild,
        appendTo: getAppendToElement(val),
        interactive: true,
        maxWidth: 'none',
        placement: 'top',
        offset: [0, 10],
        popperOptions: {
          modifiers: [
            {
              name: 'sameWidth',
              enabled: true,
              phase: 'beforeWrite',
              requires: ['computeStyles'],
              fn: ({ state }) => {
                state.styles.popper.width = `${tippyWidth}px`;
              },
              effect: ({ state }) => {
                state.elements.popper.style.width = `${
                  tippyWidth
                }px`;
              }
            },
            {
              name: 'preventOverflow',
              options: {
                boundary: getAppendToElement(),
                padding: {
                  left: 0,
                  right: 0,
                  bottom: 2,
                  top: 2
                }
                //altBoundary: true,
              },
            }
          ]
        }
      })
    }, { immediate: true, flush: 'post' })

    return {
      metadata: props.element?.file?.exif || [],
      tippyContent,
    }
  }
}
</script>

<style lang="scss">
</style>
